export default {
  v3SubmitErrBtnViewOrder: 'Xem đơn hàng',
  v3SubmitErrBtnBackHome: 'Trang chủ',
  v3SubmitErrBtnRetry: 'Thử lại',
  v3SubmitErrBtnRelogin: 'Đăng nhập lại',
  v3SubmitErrBtnSwitchPay: 'Đổi phương thức thanh toán',
  v3SubmitErrBtnReorder: 'Đặt hàng lại',
  v3SubmitErrBtnSwitchServer: 'Đổi máy chủ',
  v3SubmitErrBtnViewOrderStatus: 'Trạng thái đơn hàng',
  v3SubmitErrBtnBackStore: 'Quay lại cửa hàng',
  v3SubmitErrBtnGoUpdate: 'Cập nhật',
  v3SubmitErrBtnResubscribe: 'Đăng ký lại',
  v3SubmitErrTipUpdateApp: 'Vui lòng cập nhật qua cửa hàng ứng dụng',
  v3SubmitErrTipRelogin: 'Vui lòng đăng nhập lại',

  v3SubmitErrMsg120009: 'Đơn hàng đã được xử lý – hãy kiểm tra túi đồ trong game.',
  v3SubmitErrMsg120003: 'Thông tin sản phẩm sai – vui lòng chọn lại.',
  v3SubmitErrMsg120016: 'Gửi quá thường xuyên – vui lòng đợi vài giây và thử lại.',
  v3SubmitErrMsg120025: 'Tham số yêu cầu bất thường – vui lòng đăng nhập lại và thử.',
  v3SubmitErrMsg121012: 'Kênh thanh toán tạm thời không khả dụng – vui lòng thử phương thức khác.',
  v3SubmitErrMsg120012: 'Mạng không ổn định – vui lòng kiểm tra kết nối và thử lại.',
  v3SubmitErrMsg120002: 'Không tìm thấy nhân vật game – vui lòng tạo nhân vật trước.',
  v3SubmitErrMsg121019: 'Thông tin đơn hàng sai – vui lòng đặt lại đơn hàng.',
  v3SubmitErrMsg120024: 'Quà đăng ký trước đã nhận – không cần thao tác lại.',
  v3SubmitErrMsg120000: 'Đăng nhập hết hạn – vui lòng đăng nhập lại.',
  v3SubmitErrMsg120014: 'Mã đơn hàng không hợp lệ – vui lòng đặt lại đơn.',
  v3SubmitErrMsg121001: 'Nạp tiền vào game thất bại – vui lòng thử lại sau hoặc liên hệ hỗ trợ.',
  v3SubmitErrMsg120015: 'Số tiền thanh toán bất thường – vui lòng chọn lại sản phẩm.',
  v3SubmitErrMsg120001: 'Máy chủ không khớp – vui lòng chuyển sang máy chủ đúng.',
  v3SubmitErrMsg120020: 'Kênh thanh toán trả về lỗi – vui lòng thử phương thức khác.',
  v3SubmitErrMsg120010: 'Chức năng nạp game tạm thời đóng – vui lòng thử lại sau.',
  v3SubmitErrMsg120006: 'Xác minh số tiền thất bại – vui lòng chọn lại.',
  v3SubmitErrMsg121010: 'Yêu cầu nạp tiền trong môi trường sandbox không hợp lệ – vui lòng sử dụng phiên bản chính thức.',
  v3SubmitErrMsg120017: 'Mã đơn hàng trùng lặp – vui lòng kiểm tra xem đã thanh toán chưa.',
  v3SubmitErrMsg120022: 'Xác minh callback thanh toán thất bại – vui lòng thử lại sau.',
  v3SubmitErrMsg121000: 'Hệ thống bận – vui lòng thử lại sau.',
  v3SubmitErrMsg120011: 'Mã sản phẩm sai – vui lòng chọn lại.',
  v3SubmitErrMsg121015: 'Xác minh số tiền thanh toán thất bại – vui lòng đặt lại đơn hàng.',
  v3SubmitErrMsg120004: 'Kênh thanh toán hiện tại chưa mở – vui lòng chọn phương thức khác.',
  v3SubmitErrMsg120005: 'Kênh thanh toán đang bảo trì – vui lòng sử dụng phương thức khác.',
  v3SubmitErrMsg120007: 'ID nền tảng không hợp lệ – vui lòng đăng nhập lại.',
  v3SubmitErrMsg120008: 'Thiếu tham số yêu cầu – vui lòng gửi lại.',
  v3SubmitErrMsg120013: 'Mã đơn hàng của nhà phát triển sai – vui lòng đặt lại đơn.',
  v3SubmitErrMsg120018: 'Thanh toán bị chặn bởi kiểm soát rủi ro – vui lòng liên hệ hỗ trợ để xác minh.',
  v3SubmitErrMsg120019: 'Xác minh tên gói thất bại – vui lòng sử dụng phiên bản chính thức.',
  v3SubmitErrMsg120021: 'Xác minh mã sản phẩm thất bại – vui lòng chọn lại.',
  v3SubmitErrMsg120023: 'Quà đăng ký trước phát thưởng bất thường – vui lòng kiểm tra sau.',
  v3SubmitErrMsg120026: 'Tài khoản không tồn tại – vui lòng kiểm tra trạng thái tài khoản.',
  v3SubmitErrMsg120030: 'Tổng kho hàng không đủ – vui lòng chọn sản phẩm khác.',
  v3SubmitErrMsg120031: 'Bạn đã vượt quá số lượng giới hạn mua của sản phẩm – vui lòng điều chỉnh.',
  v3SubmitErrMsg120032: 'Phiên bản game quá cũ – vui lòng tải phiên bản mới nhất.',
  v3SubmitErrMsg120080: 'Thanh toán qua đại lý bị hạn chế bởi kiểm soát rủi ro – vui lòng sử dụng phương thức thanh toán của riêng bạn.',
  v3SubmitErrMsg120081: 'Thanh toán qua đại lý bị trì hoãn bởi kiểm soát rủi ro – vui lòng kiểm tra kết quả sau.',
  v3SubmitErrMsg121002: 'Bộ nhớ đệm đơn hàng không hợp lệ – vui lòng đặt lại đơn hàng.',
  v3SubmitErrMsg121003: 'Cấu hình nạp tiền không tồn tại – vui lòng liên hệ hỗ trợ.',
  v3SubmitErrMsg121004: 'Thiếu tham số mở rộng – vui lòng gửi lại.',
  v3SubmitErrMsg121005: 'Ghi bộ nhớ đệm thất bại – vui lòng thử lại sau.',
  v3SubmitErrMsg121006: 'Đọc bộ nhớ đệm thất bại – vui lòng thử lại sau.',
  v3SubmitErrMsg121007: 'Lỗi cấu hình loại nạp tiền – vui lòng liên hệ hỗ trợ.',
  v3SubmitErrMsg121011: 'Phát hiện trường mới từ kênh Apple – vui lòng cập nhật ứng dụng.',
  v3SubmitErrMsg121013: 'Đơn hàng gia hạn không tồn tại – vui lòng đăng ký lại.',
  v3SubmitErrMsg121014: 'Giải mã tham số nạp tiền thất bại – vui lòng gửi lại.',
  v3SubmitErrMsg121017: 'Đơn hàng này đã được hoàn tiền – vui lòng liên hệ hỗ trợ để xác nhận.',
  v3SubmitErrMsg121018: 'Đăng ký đã hết hạn – vui lòng đăng ký lại.',
  v3SubmitErrMsg121020: 'Đơn hàng đã bị hủy – vui lòng đặt lại đơn hàng.',
  v3SubmitErrMsg121021: 'Lỗi Google API – vui lòng thử lại sau.',
  v3SubmitErrMsg121022: 'Không lấy được mã truy cập – vui lòng đăng nhập lại.',
  v3SubmitErrMsg121023: 'Trạng thái đơn hàng bất thường – vui lòng kiểm tra trạng thái nhận tiền.',
  v3SubmitErrMsg121024: 'Xác nhận đơn hàng thất bại – vui lòng thử lại sau.'
};
